export function getShowButton(readingsList, selectedSensors) {
  return (
    readingsList.filter((r) => {
      return (
        r &&
        r.originalSourceSerialNumber == null &&
        selectedSensors.some(
          (s) => s.serialNumberTool === r.serialNumberMeasurementTool,
        )
      );
    }).length === 1
  );
}

export function getIsDateRangeMoreThan24Hours(selectedDate) {
  if (!selectedDate || selectedDate.length < 2) return false;
  const [start, end] = selectedDate.map((d) => new Date(d).getTime());
  return (end - start) / (1000 * 60 * 60) > 24;
}
